import { render, staticRenderFns } from "./search-empty-state.vue?vue&type=template&id=4a9fcfba&scoped=true&"
import script from "./search-empty-state.vue?vue&type=script&lang=js&"
export * from "./search-empty-state.vue?vue&type=script&lang=js&"
import style0 from "./search-empty-state.vue?vue&type=style&index=0&id=4a9fcfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9fcfba",
  null
  
)

export default component.exports